<section class="cz-tasks-component">
  <mat-accordion multi="true">
      <mat-expansion-panel *ngIf="openTasksList as openTasks" [expanded]="selectedAccordionIndex === 0">
        <mat-expansion-panel-header>
          <mat-panel-title class="truncate" *ngIf="!userDetailView">
            <span [innerHTML]="'$nav_accordions_open_tasks' | translate" class="truncate"></span> <span class="font-size-small badge" [ngClass]="taskOverdue(openTasks) ? 'active' : ''">{{ openTaskCount }}</span>
          </mat-panel-title>
          <mat-panel-title class="truncate" *ngIf="userDetailView">
            <span [innerHTML]="'$nav_accordions_assigned_to_user_tasks' | translate" class="truncate"></span>&nbsp;{{taskUser?.user?.firstName}} <span class="font-size-small badge" [ngClass]="taskOverdue(openTasks) ? 'active' : ''">{{ openTaskCount }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
    <!-- employee search controller -->
    <div class="list-actions" *ngIf="isAdmin">
      <div class="row">
        <div class="col-xs-4">
         <mat-form-field class="form-full-width-field custome-class-close">
            <mat-label [innerHTML]="'$workload_task_assigned_to_dialog_search_employee' | translate"></mat-label>
            <input type="search" matInput [formControl]="employeeSearchControl" >
              <span class="searchhiddenToolTip">
                <mat-icon matSuffix>search</mat-icon>
                <span class="search-download-tool-tip" [innerHTML]="'$common_search' | translate"></span>
              </span>
            </mat-form-field>
          </div>
      </div>
    </div>

        <cz-task-card *ngFor="let openTask of openTasks" [task]="openTask"></cz-task-card>
      </mat-expansion-panel>
      <mat-expansion-panel *ngIf="tasksOpenAndTheSubjectIsUser$ | async as openAndTheSubjectIsUserTasks" [expanded]="selectedAccordionIndex === 1">
        <mat-expansion-panel-header>
          <mat-panel-title class="truncate" *ngIf="!userDetailView">
            <span [innerHTML]="'$nav_accordions_open_for_me_tasks' | translate" class="truncate"></span> <span class="font-size-small badge" [ngClass]="taskOverdue(openAndTheSubjectIsUserTasks) ? 'active' : ''">{{ openAndTheSubjectIsUserTasks.length }}</span>
          </mat-panel-title>
          <mat-panel-title class="truncate" *ngIf="userDetailView">
            <span [innerHTML]="'$nav_accordions_open_for_user_tasks' | translate" class="truncate"></span>&nbsp;{{taskUser?.user?.firstName}} <span class="font-size-small badge" [ngClass]="taskOverdue(openAndTheSubjectIsUserTasks) ? 'active' : ''">{{ openAndTheSubjectIsUserTasks.length }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <cz-task-card *ngFor="let taskOpenAndTheSubjectIsUser of openAndTheSubjectIsUserTasks" [task]="taskOpenAndTheSubjectIsUser"></cz-task-card>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="tasksCompletedByUser$ | async as completedTasks" [expanded]="selectedAccordionIndex === 2">
        <mat-expansion-panel-header>
          <mat-panel-title class="truncate" *ngIf="!userDetailView">
            <span [innerHTML]="'$nav_accordions_completed_tasks' | translate" class="truncate"></span> <span class="font-size-small badge">{{ getVisibleCompletedByTasks() }}</span>
          </mat-panel-title>
          <mat-panel-title class="truncate" *ngIf="userDetailView">
            <span [innerHTML]="'$nav_accordions_completed_tasks_by_user' | translate" class="truncate"></span>&nbsp;{{taskUser?.user?.firstName}} <span class="font-size-small badge">{{ getVisibleCompletedByTasks() }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <cz-task-card *ngFor="let taskCompleted of completedTasks | arraySlice: closedByTaskCount" [task]="taskCompleted"></cz-task-card>
        <div *ngIf="!allShownBy" class="load-more-container">
          <button mat-button (click)="loadMoreClosedByTasks()" color="accent" [innerHTML]="'$btn_load_more' | translate"></button>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel *ngIf="tasksCompletedForUser$ | async as completedTasks" [expanded]="selectedAccordionIndex === 3">
        <mat-expansion-panel-header>
          <mat-panel-title class="truncate" *ngIf="!userDetailView">
            <span [innerHTML]="'$nav_accordions_completed_tasks_for' | translate" class="truncate"></span> <span class="font-size-small badge">{{ getVisibleCompletedForTasks() }}</span>
          </mat-panel-title>
          <mat-panel-title class="truncate" *ngIf="userDetailView">
            <span [innerHTML]="'$nav_accordions_completed_tasks_for_user' | translate" class="truncate"></span>&nbsp;{{taskUser?.user?.firstName}} <span class="font-size-small badge">{{ getVisibleCompletedForTasks() }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <cz-task-card *ngFor="let taskCompleted of completedTasks | arraySlice: closedForTaskCount" [task]="taskCompleted"></cz-task-card>
        <div *ngIf="!allShownFor" class="load-more-container">
          <button mat-button (click)="loadMoreClosedForTasks()" color="accent" [innerHTML]="'$btn_load_more' | translate"></button>
        </div>
      </mat-expansion-panel>
      
    </mat-accordion>
</section>
